import {memo} from "react";
import {useSelector} from "react-redux";
import * as yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup/dist/yup";
import {useTranslation} from "react-i18next";

import * as Form from "../form-components";
import {withLoading} from "../../HOCs";

function CompanyShareForm(props) {

    const { t } = useTranslation();

    const {onCancel, onSubmitForm, form} = props;

    const tags = useSelector(state => state.tags.tags);
    const loading = useSelector(state => state.item.isLoading === "setItem" || state.item.isLoading === 'updateItem');

    const getFieldByForm = (currentForm) =>{
        const fieldItem = {}
        const fieldValue = {}

        if(["shares", "shareholder-company", "stock"].includes(currentForm)){
            fieldValue.company = props?.company ?? ""
            fieldItem.company = yup.string().required(t('required'))
        }

        if(["shareholder"].includes(currentForm)){
            fieldValue.person = props?.person ?? ""
            fieldItem.person = yup.string().required(t('required'))
        }

        return {fieldItem, fieldValue}
    }

    const {fieldItem, fieldValue} = getFieldByForm(form);

    const schema = yup.object().shape({
        share: yup.number().required(t('required')),
        sinceDate: yup.date().required(t('required')),
        ...fieldItem
    });

    const {
        handleSubmit,
        control,
        formState: { errors }
    } = useForm({
        defaultValues: {
            share: props?.share ?? 0,
            sinceDate: props?.sinceDate ?? "",
            ...fieldValue
        },
        resolver: yupResolver(schema),
    });

    const onSubmit = async (values)=>{
        const response = await onSubmitForm(values);
        if(response) {
            onCancel()
        }
        return response
    }

    return (
        <Form.FormWrapper onSubmit={handleSubmit(onSubmit)}>
            {["shares", "shareholder-company", "stock"].includes(form) && <Form.FormSelect
                displayEmpty
                id="company-share-company"
                name="company"
                items={tags.map(item => ({value: item.id, label: t(item.name)}))}
                control={control}
                size="small"
                errors={errors.company}
                placeholder={t('Company')}
            />}
            {form === "shareholder" && <Form.FormSelect
                displayEmpty
                id="company-share-person"
                name="person"
                items={tags.map(item => ({value: item.id, label: t(item.name)}))}
                control={control}
                size="small"
                errors={errors.person}
                placeholder={t('Person')}
            />}
            <Form.FormInput
                id="company-share-share"
                type="number"
                name="share"
                control={control}
                size="small"
                errors={errors.share}
                placeholder={t('Share')}
            />
            <Form.FormDatePicker
                id="company-share-sinceDate"
                name="sinceDate"
                control={control}
                errors={errors.sinceDate}
                placeholder={t('Since')}
            />
            <Form.FormButtons loading={loading} onCancel={onCancel}/>
        </Form.FormWrapper>
    )
}

export default memo(withLoading(CompanyShareForm))